import { render, staticRenderFns } from "./NewsroomItem.vue?vue&type=template&id=684e4ec6&scoped=true&"
import script from "./NewsroomItem.vue?vue&type=script&lang=js&"
export * from "./NewsroomItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsroomItem.vue?vue&type=style&index=0&id=684e4ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e4ec6",
  null
  
)

export default component.exports